import React, { FC, useEffect } from 'react';
import { LoadingPage } from 'Shared/components';
import { useAsyncError } from 'Shared/hooks';
import { GetDetailsResponseType } from 'QuoteApp/services/endpoints/GetDetails';
import { useAppContext } from 'QuoteApp/services/providers';
import { runWithPolling } from 'QuoteApp/utils';

export const IN_PROGRESS = ['third_party_in_progress', 'bind_in_progress'];

const messages: Record<string, string> = {
  third_party_in_progress: 'Third party reports in progress...',
  bind_in_progress: 'Checkout in progress...',
};

export const ResolveInProgressStatus: FC = () => {
  const { details, refreshDetails } = useAppContext();
  const throwError = useAsyncError();

  useEffect(() => {
    const pollStatus = async () => {
      await runWithPolling<GetDetailsResponseType>(
        refreshDetails,
        statusResponse => !IN_PROGRESS.includes(statusResponse.status)
      ).catch(() => {
        throwError(new Error('An error occurred, please try again.'));
      });
    };
    if (IN_PROGRESS.includes(details.status)) {
      pollStatus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LoadingPage message={messages[details.status]} />;
};
